import clsx from 'clsx';
import { endOfDay } from 'date-fns';
import { zonedTimeToUtc } from 'date-fns-tz';
import { useParams } from 'react-router-dom';
import { useFilter } from '../../FilterContext';
import { useIntl } from 'react-intl';
import SearchInputGroup from '../../components/SearchInputGroup';
import SingleSelection from '../../components/SingleSelection';
import DatePickerFilter from '../components/DatePickerFilter';
import { ResultStatus } from '../../../../../pages/shuftiPro/mappings';

export function AmlBusinessFilter() {
  const params = useParams();
  const intl = useIntl();
  const { globalFilter, setGlobalFilter } = useFilter();
  const filterKey = 'amlBusinessEnquiries';

  return (
    <>
      <div className={clsx(params.id ? 'blur' : '')}>
        <div className='d-inline-flex flex-wrap'>
          {/* Select */}
          <div className='d-flex'>
            {/* Date Picker */}
            <DatePickerFilter
              onChange={(selectedDate) =>
                setGlobalFilter({
                  ...globalFilter,
                  [filterKey]: {
                    ...globalFilter?.[filterKey],
                    enquiry_date: selectedDate && {
                      from: zonedTimeToUtc(new Date(selectedDate.start), 'Hongkong').toISOString(),
                      to: zonedTimeToUtc(
                        new Date(endOfDay(selectedDate.end)),
                        'Hongkong'
                      ).toISOString(),
                    },
                  },
                })
              }
              globalFilterValue={
                globalFilter?.[filterKey]?.enquiry_date?.from &&
                globalFilter?.[filterKey]?.enquiry_date?.to && {
                  startDate: new Date(globalFilter?.[filterKey]?.enquiry_date?.from),
                  endDate: new Date(globalFilter?.[filterKey]?.enquiry_date?.to),
                }
              }
              label={intl.formatMessage({ id: 'SHUFTI.ENQUIRIES.REQUEST_DATE' })}
              placeholder={intl.formatMessage({ id: 'SHUFTI.ENQUIRIES.FILTER_REQUEST_DATE' })}
              className='me-6'
            />

            {/* Enquiry Type */}
            <SingleSelection
              title={intl.formatMessage({ id: 'SHUFTI.ENQUIRIES.SCREENING_FREQUENCY' })}
              globalFilterValue={globalFilter?.[filterKey]?.['enquiry_data.ongoing']?.values}
              options={[
                {
                  value: true,
                  label: intl.formatMessage({ id: 'SHUFTI.ENQUIRIES.TYPE_OPTIONS.ONGOING' }),
                },
                {
                  value: false,
                  label: intl.formatMessage({ id: 'SHUFTI.ENQUIRIES.TYPE_OPTIONS.ONE_TIME' }),
                },
              ]}
              isClearable
              onChange={(e) => {
                setGlobalFilter({
                  ...globalFilter,
                  [filterKey]: {
                    ...globalFilter?.[filterKey],
                    'enquiry_data.ongoing':
                      typeof e?.value === 'boolean' ? { type: 'in', values: [e] } : undefined,
                  },
                });
              }}
              className='min-w-175px'
            />

            {/* Result Status */}
            <SingleSelection
              title={intl.formatMessage({ id: 'SHUFTI.ENQUIRIES.RESULT_STATUS' })}
              globalFilterValue={globalFilter?.[filterKey]?.['enquiry_result_event']?.values}
              options={[
                {
                  value: ResultStatus.ACCEPTED,
                  label: intl.formatMessage({ id: 'SHUFTI.ENQUIRIES.STATUS_OPTIONS.ACCEPTED' }),
                },
                {
                  value: ResultStatus.DECLINED,
                  label: intl.formatMessage({ id: 'SHUFTI.ENQUIRIES.STATUS_OPTIONS.DECLINED' }),
                },
              ]}
              isClearable
              onChange={(e) => {
                setGlobalFilter({
                  ...globalFilter,
                  [filterKey]: {
                    ...globalFilter?.[filterKey],
                    enquiry_result_event: e?.value ? { type: 'in', values: [e] } : undefined,
                  },
                });
              }}
              className='min-w-175px'
            />
          </div>

          {/* Search */}
          <SearchInputGroup
            inputs={[
              {
                key: 'result.reference',
                title: intl.formatMessage({ id: 'SHUFTI.ENQUIRIES.REFERENCE_ID' }),
              },
              {
                key: 'enquiry_data.business_name',
                title: intl.formatMessage({ id: 'SHUFTI.ENQUIRIES.BUSINESS_NAME' }),
                minWidth: 200,
              },
              {
                key: 'merchant_id',
                title: intl.formatMessage({ id: 'CLIENTS.CLIENT_ID' }),
                minWidth: 200,
              },
            ]}
            section={filterKey}
            globalFilterValue={globalFilter}
            onSubmit={(searchValues) =>
              setGlobalFilter({
                ...globalFilter,
                [filterKey]: { ...globalFilter?.[filterKey], ...searchValues },
              })
            }
            onClear={(searchValues) =>
              setGlobalFilter({
                ...globalFilter,
                [filterKey]: { ...globalFilter?.[filterKey], ...searchValues },
              })
            }
          />
        </div>
      </div>
    </>
  );
}
